// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_240d208","slideImage":"_7502776","pagination":"_af9cd82"};